import { useLoaderData } from 'react-router-dom';

// Services
import { getFooter, type FooterType } from '@/services/footer/footerService';
import { getHeader, type HeaderType } from '@/services/header/headerService';

// Components
import Header from '@/components/organisms/Header/Header';
import Footer from '@/components/organisms/Footer/Footer';

// Utils
import { getLocale } from '@/utils/localeSlug';

// Styles
import styles from './ErrorFallback.module.css';

export async function errorLoader({ request }: { request: Request }) {
  const url = new URL(request.url);

  const locale = getLocale(url);

  const [header, footer] = await Promise.all([
    getHeader(locale),
    getFooter(locale),
  ]);
  
  return {
    header,
    footer,
  };
}

function ErrorFallback() {
  const data = useLoaderData() as Awaited<ReturnType<typeof errorLoader>>;
  
  if (!data) return null; 

  const { header, footer } = data;
  
  return (
    <main>
      <Header
        color='dark'
        header={header as HeaderType}
      />

      <div className={styles.body}>
        404
      </div>
      
      <Footer
        footer={footer as FooterType}
      />
    </main>
  );
}

export default ErrorFallback;
